// Natural / alphanumeric comparison for part numbers (product_number).
// Part numbers mix digits, letters, hyphens and spaces (e.g. "1000", "1000-018",
// "1000B", "02-FL53"), so a plain numeric parse is wrong. localeCompare with
// numeric:true sorts embedded digit runs numerically while keeping letters lexical.
export default function comparePartNumbers(a, b) {
    const av = a == null ? '' : String(a);
    const bv = b == null ? '' : String(b);
    return av.localeCompare(bv, undefined, {numeric: true, sensitivity: 'base'});
}
